module.exports = function ($sce, settingsService, $state, searchService, $sanitize) {
    return {
        restrict: 'E',
        scope: {
            isRecipes: '='
        },
        link($scope) {
            $scope.searchTerm = '';
            $scope.originalSearchTerm = $sanitize($state.params.searchTerm).replace(/-/g, ' ');

            searchService.getSearchCounts($sanitize($state.params.searchTerm));

            $scope.pageName = 'results';
            if ($state.current.name === 'shop.search.products') {
                $scope.pageName = 'products';
            } else if ($state.current.name === 'shop.search.specials') {
                $scope.pageName = 'specials';
            } else if ($state.current.name === 'shop.search.recipes') {
                $scope.pageName = 'recipes';
            } else if ($state.current.name === 'shop.search.articles') {
                $scope.pageName = 'articles';
            }

            settingsService.getSettingValue('Search', 'ZeroSearchResultsMessage').then(function (setting) {
                const message = setting.replace('{search}', $scope.originalSearchTerm).trim();
                $scope.EmptyProductSearchMessage = $sce.trustAsHtml(message);
            });
        },
        template: require('./search-zero-results-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-zero-results-directive.js
 **/